var fileUploadGuid;
var validator = null;
var FilesAddedCount = 0;
var subOrderContext = 0;

function initPrintOnDemand($el) {
	PanteraScript.PanteraScriptService.CalculateOrder = function (sessionId, contactId, drawingEntryList, specEntryList, shippingSpeed, largeFormatBindingType, largeFormatPaperType, largeFormatPaperSize, smallFormatBindingType, smallFormatPaperType, isSaturdayDelivery, isDownload, drawingQuantity, specQuantity, onSuccess, onFailed, userContext) {
		PanteraScript.PanteraScriptService._staticInstance.CalculateOrder(sessionId, contactId, drawingEntryList, specEntryList, shippingSpeed, largeFormatBindingType, largeFormatPaperType, largeFormatPaperSize, smallFormatBindingType, smallFormatPaperType, isSaturdayDelivery, isDownload, drawingQuantity, specQuantity, onSuccess, onFailed, userContext);
	};

	PanteraScript.PanteraScriptService.SubmitOrder = function (sessionId, contactOrderList, drawingEntryList, specEntryList, shippingSpeed, largeFormatBindingType, largeFormatPaperType, largeFormatPaperSize, smallFormatBindingType, smallFormatPaperType, projectId, poNumber, orderDescription, orderNotes, isDownload, onAccount, contactInfoAlt, notifyEmailAlt, drawingQuantity, specQuantity, onSuccess, onFailed, userContext) {
		PanteraScript.PanteraScriptService._staticInstance.SubmitOrder(sessionId, contactOrderList, drawingEntryList, specEntryList, shippingSpeed, largeFormatBindingType, largeFormatPaperType, largeFormatPaperSize, smallFormatBindingType, smallFormatPaperType, projectId, poNumber, orderDescription, orderNotes, isDownload, onAccount, contactInfoAlt, notifyEmailAlt, drawingQuantity, specQuantity, onSuccess, onFailed, userContext);
	};

	if (getParameterByName('suborder') !== '') {
		subOrderContext = parseInt(getParameterByName('suborder'));
	}

	validator = jQuery("Form[name='Form']").validate({
		onsubmit: false,
		onkeyup: false,
		onclick: false,
		showErrors: function (errorMap, errorList) {
			for (var i = 0; errorList[i]; i++) {
				var element = this.errorList[i].element;
				//solves the problem with brute force
				//remove existing error label and thus force plugin to recreate it
				//recreation == call to errorplacement function
				this.errorsFor(element).remove();
			}
			this.defaultShowErrors();
		},
		errorPlacement: function (error, element) {
			error.html('<br />' + error.text());
			if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
				error.appendTo(element.parent().parent());
			else
				error.appendTo(element.parent());
		},
		errorClass: "pjq-errortext",
		ignore: ".pjq-validate-ignore"
	});

	// Load the Master Template, and render it in the container called pjq-main on the page.
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PRINTONDEMAND, 'Master', {isOldModule: true}), $el, {}, function () {
		PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PRINTONDEMAND, 'Documents', {isOldModule: true}), $el.find('#pod-documents'), {}, function () {
			PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PRINTONDEMAND, 'OrderOptions', {isOldModule: true}), $el.find('#pod-options'), {}, function () {
				jQuery("#step2button").button();
				jQuery("#cancel-upload").button();
				jQuery("#clear-recipient").button();
				jQuery("#prev-step").button();
				jQuery("#printondemand-send").button();
				jQuery("#cancel-order").button();

				PanteraScript.PanteraScriptService.GetPrintOnDemandSettings(pjqSessionId, PrintOnDemandSettingsC, onScriptError);
			});
		});
	});
}

function CancelClick() {
	window.location.href = "/default.aspx";
}

function FilesAddedClick() {
	FilesAddedCount = 1;
}

function FilesZeroClick() {
	FilesAddedCount = 0;
}

function showInfoDialog(titleText, message, iconClass) {
	if (iconClass)
		jQuery('#dialog-message-icon').addClass(iconClass);
	else
		jQuery('#dialog-message-icon').addClass('ui-icon-info');

	jQuery('#dlg-message-span').html(message);
	jQuery("#dialog-message").dialog({
		modal: true,
		title: titleText,
		buttons: {
			Ok: function () {
				$(this).dialog("close");
			}
		}
	});
}

jQuery.fn.outerHTML = function (s) {
	return s
		? this.before(s).remove()
		: jQuery("<p>").append(this.eq(0).clone()).html();
};